export const HOME_FETCH_MODEL_DATA_BEGIN = 'HOME_FETCH_MODEL_DATA_BEGIN';
export const HOME_FETCH_MODEL_DATA_SUCCESS = 'HOME_FETCH_MODEL_DATA_SUCCESS';
export const HOME_FETCH_MODEL_DATA_FAILURE = 'HOME_FETCH_MODEL_DATA_FAILURE';
export const HOME_FETCH_MODEL_DATA_DISMISS_ERROR = 'HOME_FETCH_MODEL_DATA_DISMISS_ERROR';
export const HOME_SET_FILTER = 'HOME_SET_FILTER';
export const HOME_SET_ASSIGNMENT_FORM_OPEN = 'HOME_SET_ASSIGNMENT_FORM_OPEN';
export const HOME_CHANGE_ASSIGNMENT = 'HOME_CHANGE_ASSIGNMENT';
export const HOME_SAVE_SCHEDULE_BEGIN = 'HOME_SAVE_SCHEDULE_BEGIN';
export const HOME_SAVE_SCHEDULE_SUCCESS = 'HOME_SAVE_SCHEDULE_SUCCESS';
export const HOME_SAVE_SCHEDULE_FAILURE = 'HOME_SAVE_SCHEDULE_FAILURE';
export const HOME_SAVE_SCHEDULE_DISMISS_ERROR = 'HOME_SAVE_SCHEDULE_DISMISS_ERROR';
export const HOME_OPTIMIZE_SCHEDULE_BEGIN = 'HOME_OPTIMIZE_SCHEDULE_BEGIN';
export const HOME_OPTIMIZE_SCHEDULE_SUCCESS = 'HOME_OPTIMIZE_SCHEDULE_SUCCESS';
export const HOME_OPTIMIZE_SCHEDULE_FAILURE = 'HOME_OPTIMIZE_SCHEDULE_FAILURE';
export const HOME_OPTIMIZE_SCHEDULE_DISMISS_ERROR = 'HOME_OPTIMIZE_SCHEDULE_DISMISS_ERROR';
export const HOME_CLEAR_SCHEDULE_BEGIN = 'HOME_CLEAR_SCHEDULE_BEGIN';
export const HOME_CLEAR_SCHEDULE_SUCCESS = 'HOME_CLEAR_SCHEDULE_SUCCESS';
export const HOME_CLEAR_SCHEDULE_FAILURE = 'HOME_CLEAR_SCHEDULE_FAILURE';
export const HOME_CLEAR_SCHEDULE_DISMISS_ERROR = 'HOME_CLEAR_SCHEDULE_DISMISS_ERROR';
export const HOME_START_SCHEDULING_BEGIN = 'HOME_START_SCHEDULING_BEGIN';
export const HOME_START_SCHEDULING_SUCCESS = 'HOME_START_SCHEDULING_SUCCESS';
export const HOME_START_SCHEDULING_FAILURE = 'HOME_START_SCHEDULING_FAILURE';
export const HOME_START_SCHEDULING_DISMISS_ERROR = 'HOME_START_SCHEDULING_DISMISS_ERROR';
export const HOME_READ_SCHEDULING_RESULT_BEGIN = 'HOME_READ_SCHEDULING_RESULT_BEGIN';
export const HOME_READ_SCHEDULING_RESULT_SUCCESS = 'HOME_READ_SCHEDULING_RESULT_SUCCESS';
export const HOME_READ_SCHEDULING_RESULT_FAILURE = 'HOME_READ_SCHEDULING_RESULT_FAILURE';
export const HOME_READ_SCHEDULING_RESULT_DISMISS_ERROR = 'HOME_READ_SCHEDULING_RESULT_DISMISS_ERROR';
export const HOME_SET_SCATTER_CHART_AXIS = 'HOME_SET_SCATTER_CHART_AXIS';
export const HOME_SET_UPLOAD_MODE = 'HOME_SET_UPLOAD_MODE';
export const HOME_PUBLISH_ASSIGNMENTS_BEGIN = 'HOME_PUBLISH_ASSIGNMENTS_BEGIN';
export const HOME_PUBLISH_ASSIGNMENTS_SUCCESS = 'HOME_PUBLISH_ASSIGNMENTS_SUCCESS';
export const HOME_PUBLISH_ASSIGNMENTS_FAILURE = 'HOME_PUBLISH_ASSIGNMENTS_FAILURE';
export const HOME_PUBLISH_ASSIGNMENTS_DISMISS_ERROR = 'HOME_PUBLISH_ASSIGNMENTS_DISMISS_ERROR';
export const HOME_UPDATE_PLAN = 'HOME_UPDATE_PLAN';
export const HOME_SAVE_PLANS_BEGIN = 'HOME_SAVE_PLANS_BEGIN';
export const HOME_SAVE_PLANS_SUCCESS = 'HOME_SAVE_PLANS_SUCCESS';
export const HOME_SAVE_PLANS_FAILURE = 'HOME_SAVE_PLANS_FAILURE';
export const HOME_SAVE_PLANS_DISMISS_ERROR = 'HOME_SAVE_PLANS_DISMISS_ERROR';
export const HOME_CREATE_SEASON_BEGIN = 'HOME_CREATE_SEASON_BEGIN';
export const HOME_CREATE_SEASON_SUCCESS = 'HOME_CREATE_SEASON_SUCCESS';
export const HOME_CREATE_SEASON_FAILURE = 'HOME_CREATE_SEASON_FAILURE';
export const HOME_CREATE_SEASON_DISMISS_ERROR = 'HOME_CREATE_SEASON_DISMISS_ERROR';
export const HOME_DELETE_SEASON_BEGIN = 'HOME_DELETE_SEASON_BEGIN';
export const HOME_DELETE_SEASON_SUCCESS = 'HOME_DELETE_SEASON_SUCCESS';
export const HOME_DELETE_SEASON_FAILURE = 'HOME_DELETE_SEASON_FAILURE';
export const HOME_DELETE_SEASON_DISMISS_ERROR = 'HOME_DELETE_SEASON_DISMISS_ERROR';
export const HOME_SYNC_PLANS_WITH_PCO_BEGIN = 'HOME_SYNC_PLANS_WITH_PCO_BEGIN';
export const HOME_SYNC_PLANS_WITH_PCO_SUCCESS = 'HOME_SYNC_PLANS_WITH_PCO_SUCCESS';
export const HOME_SYNC_PLANS_WITH_PCO_FAILURE = 'HOME_SYNC_PLANS_WITH_PCO_FAILURE';
export const HOME_SYNC_PLANS_WITH_PCO_DISMISS_ERROR = 'HOME_SYNC_PLANS_WITH_PCO_DISMISS_ERROR';
export const HOME_DISMISS_SYNC_PLANS_WITH_PCO_MESSAGES = 'HOME_DISMISS_SYNC_PLANS_WITH_PCO_MESSAGES';
export const HOME_SAVE_SEASON_BEGIN = 'HOME_SAVE_SEASON_BEGIN';
export const HOME_SAVE_SEASON_SUCCESS = 'HOME_SAVE_SEASON_SUCCESS';
export const HOME_SAVE_SEASON_FAILURE = 'HOME_SAVE_SEASON_FAILURE';
export const HOME_SAVE_SEASON_DISMISS_ERROR = 'HOME_SAVE_SEASON_DISMISS_ERROR';
export const HOME_SET_CURRENT_SEASON = 'HOME_SET_CURRENT_SEASON';
export const HOME_SET_SELECTED_SCHEDULE = 'HOME_SET_SELECTED_SCHEDULE';
export const HOME_FETCH_SCHEDULE_BEGIN = 'HOME_FETCH_SCHEDULE_BEGIN';
export const HOME_FETCH_SCHEDULE_SUCCESS = 'HOME_FETCH_SCHEDULE_SUCCESS';
export const HOME_FETCH_SCHEDULE_FAILURE = 'HOME_FETCH_SCHEDULE_FAILURE';
export const HOME_FETCH_SCHEDULE_DISMISS_ERROR = 'HOME_FETCH_SCHEDULE_DISMISS_ERROR';
export const HOME_SYNC_WORKERS_WITH_PCO_BEGIN = 'HOME_SYNC_WORKERS_WITH_PCO_BEGIN';
export const HOME_SYNC_WORKERS_WITH_PCO_SUCCESS = 'HOME_SYNC_WORKERS_WITH_PCO_SUCCESS';
export const HOME_SYNC_WORKERS_WITH_PCO_FAILURE = 'HOME_SYNC_WORKERS_WITH_PCO_FAILURE';
export const HOME_SYNC_WORKERS_WITH_PCO_DISMISS_ERROR = 'HOME_SYNC_WORKERS_WITH_PCO_DISMISS_ERROR';
export const HOME_FETCH_MISSING_PROPERTIES_BEGIN = 'HOME_FETCH_MISSING_PROPERTIES_BEGIN';
export const HOME_FETCH_MISSING_PROPERTIES_SUCCESS = 'HOME_FETCH_MISSING_PROPERTIES_SUCCESS';
export const HOME_FETCH_MISSING_PROPERTIES_FAILURE = 'HOME_FETCH_MISSING_PROPERTIES_FAILURE';
export const HOME_FETCH_MISSING_PROPERTIES_DISMISS_ERROR = 'HOME_FETCH_MISSING_PROPERTIES_DISMISS_ERROR';
export const HOME_CREATE_SCHEDULE_BEGIN = 'HOME_CREATE_SCHEDULE_BEGIN';
export const HOME_CREATE_SCHEDULE_SUCCESS = 'HOME_CREATE_SCHEDULE_SUCCESS';
export const HOME_CREATE_SCHEDULE_FAILURE = 'HOME_CREATE_SCHEDULE_FAILURE';
export const HOME_CREATE_SCHEDULE_DISMISS_ERROR = 'HOME_CREATE_SCHEDULE_DISMISS_ERROR';
export const HOME_FETCH_EMAIL_BEGIN = 'HOME_FETCH_EMAIL_BEGIN';
export const HOME_FETCH_EMAIL_SUCCESS = 'HOME_FETCH_EMAIL_SUCCESS';
export const HOME_FETCH_EMAIL_FAILURE = 'HOME_FETCH_EMAIL_FAILURE';
export const HOME_FETCH_EMAIL_DISMISS_ERROR = 'HOME_FETCH_EMAIL_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js